import { render } from "./LoaderComponent.vue?vue&type=template&id=22e0f25e"
import script from "./LoaderComponent.vue?vue&type=script&lang=js"
export * from "./LoaderComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/macmini/Sites/self-ship/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__